<template>
    <div>

        <div v-if="editGrupo && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitGrupoUsuario" v-if="!editGrupo || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editGrupo || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                            <el-select v-model="dados.situacao">
                                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                <el-option :key="false" label="INATIVO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
                            <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Descrição" prop="descricao" key="descricao">
                            <el-input type="textarea" :rows="2" v-model="dados.descricao"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Permissões" prop="permissao_ids" key="permissao_ids">
                            <el-select v-model="dados.permissao_ids" filterable clearable multiple placeholder="Selecione permissões">
                                <el-option v-for="(item, i) in permissoes" :key="i" :label="item.nome + ' (' + item.chave + ')'" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-grupo-usuario" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editGrupo: false,
        permissoes: [],
        dados: {
            id: '',
            situacao: true,
            nome: '',
            descricao: '',
            permissao_ids: []
        }
    }),
    mounted(){
        this.getAllPermissoes();
    },
    methods:{
        getAllPermissoes(){
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/permissao/getAll`, this.$store.getters.getHeaderAuth).then(response => {
                this.permissoes = JSON.parse(JSON.stringify(response.data));
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        getGrupoById(id){
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/grupo-usuario/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {
                const tmp = JSON.parse(JSON.stringify(response.data));
                this.dados = {
                    id: tmp.id,
                    situacao: tmp.situacao,
                    nome: tmp.nome,
                    descricao: tmp.descricao,
                    permissao_ids: (tmp.permissoes || []).map(p => p.id)
                }
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        onSubmitGrupoUsuario(){

            document.getElementById("btn-grupo-usuario").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                if(this.editGrupo){
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/grupo-usuario/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(() => {
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitGrupoUsuario');
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }else{
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/grupo-usuario/store`, this.dados, this.$store.getters.getHeaderAuth).then(() => {
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitGrupoUsuario');
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        formatData(field, size = null){
            if(!this.dados[field]) return false;
            if(size && this.dados[field].length < size) this.dados[field] = '';
            this.dados[field] = this.dados[field].toUpperCase();
            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if(value){
                    this.getGrupoById(value);
                    this.editGrupo = true;
                }
            }
        },
    }
}
</script>

